var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState, } from "react";
var Context = createContext(null);
var Provider = function (props) {
    var _a = useState({
        menu: {
            list: props.menus,
            open: false,
        },
        profile: {
            data: props.profileDetail,
            open: false,
        },
        floatMenu: {
            open: false,
        },
        bottomItemOpen: false,
        currentPath: props.currentPath,
        onRouteChange: props.onRouteChange,
    }), state = _a[0], setState = _a[1];
    var menuToggle = useCallback(function (open) {
        if (!open) {
            setState(function (prev) { return (__assign(__assign({}, prev), { bottomItemOpen: !state.bottomItemOpen })); });
            setTimeout(function () {
                setState(function (prev) { return (__assign(__assign({}, prev), { menu: __assign(__assign({}, prev.menu), { open: open ? open : !prev.menu.open }) })); });
            }, 100);
        }
        else {
            setState(function (prev) { return (__assign(__assign({}, prev), { menu: __assign(__assign({}, prev.menu), { open: open ? open : !prev.menu.open }), bottomItemOpen: !state.bottomItemOpen })); });
        }
    }, [state.bottomItemOpen]);
    var profileToggle = useCallback(function (open) {
        setState(function (prev) { return (__assign(__assign({}, prev), { profile: __assign(__assign({}, prev.profile), { open: open ? open : !prev.profile.open }) })); });
    }, []);
    var floatMenuToggle = useCallback(function (open) {
        setState(function (prev) { return (__assign(__assign({}, prev), { floatMenu: __assign(__assign({}, prev.floatMenu), { open: open ? open : !prev.floatMenu.open }) })); });
    }, []);
    useEffect(function () {
        setState(function (prev) { return (__assign(__assign({}, prev), { currentPath: props.currentPath, showPageTitle: props.showPageTitle, titleComponent: props.titleComponent })); });
    }, [props.currentPath, props.showPageTitle, props.titleComponent]);
    var value = __assign(__assign({}, state), { menuToggle: menuToggle, profileToggle: profileToggle, floatMenuToggle: floatMenuToggle });
    return (_jsx(Context.Provider, __assign({ value: value }, { children: props.children(value) })));
};
export var useLayoutConsumers = function () { return useContext(Context); };
export { Provider };
